module.exports = __webpack_public_path__ + "img/Klaudia.fd524d3e.jpg";